import { PrescriptionDrug, PrescriptionFrequency } from "../@types";

const prescriptionDrug: PrescriptionDrug = {
  rxcui: "2345",
  ndc: "23456",
  name: "Ibuprofen - IBUPROFEN",
  quantity: "60",
  package_type: "PACKAGE_TYPE_BLISTER",
  package_size: "1",
  package_units: "60",
  strength: "200",
  strength_units: "mg",
  form: "DRUG_FORM_TABLET",
  frequency: PrescriptionFrequency.DAYS_30,
  is_generic: true,
  package_quantity: "2",
  use_package_quantity: false,
};

export default prescriptionDrug;
